import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../Slot';
import { Layout } from '../styles';

const HorizontalLargeAndSmall = ({ slot }) => {
	const smallSlot = slot[1];
	return (
		<Layout>
			<Slot
				top={5}
				left={5}
				width={60}
				height={90}
				component={slot[0].type}
				data={slot[0].data}
				layout={slot[0].layout}
			/>
			<Slot
				top={smallSlot.type === 'image' ? 0 : 5}
				left={smallSlot.type === 'image' ? 75 : 70}
				width={smallSlot.type === 'image' ? 35 : 25}
				height={90}
				component={slot[1].type}
				data={slot[1].data}
				layout={slot[1].layout}
			/>
		</Layout>
	)
}

HorizontalLargeAndSmall.defaultProps = {
	slot: []
}

HorizontalLargeAndSmall.propTypes = {
	slot: PropTypes.array,
}

export default HorizontalLargeAndSmall
